module.exports = __webpack_public_path__ + "static/media/consulenza.e4276d81.jpg";